// Los carruseles del Inicio de la app (Widgets, Animaciones LIVE y Gaming).
// El modelo es el MISMO que usa la app: se importa su archivo tal cual (deja
// TCHomeShowcase en global), así los topes y la limpieza no se copian aquí.
// También su hoja de estilos: la vista previa del editor pinta las tarjetas
// con las clases de la app (todas sus reglas cuelgan de .hm), así que se ve
// lo mismo que verá el usuario, también al pasar el ratón.
import '../../../renderer/tabs/inicio/componentes/destacados-modelo.js';
// El popup «Incluido en Premium» (sus textos se editan en la misma página): su
// modelo, también el de la app; necesita el de los carruseles cargado antes.
import '../../../renderer/tabs/inicio/componentes/plan-modelo.js';
import '../../../renderer/styles/views/home-dashboard.css';

export const HomeShowcase = globalThis.TCHomeShowcase;
export const HomePlanModal = globalThis.TCHomePlanModal;

// Los idiomas de la app (los del modelo), con su nombre en los desplegables y
// en el prompt de traducción.
const LANG_NAMES = {
  es: ['Español', 'Spanish'], en: ['English', 'English'], fr: ['Français', 'French'], de: ['Deutsch', 'German'],
  it: ['Italiano', 'Italian'], pt: ['Português', 'Portuguese'], ru: ['Русский', 'Russian'], tr: ['Türkçe', 'Turkish'],
  ar: ['العربية', 'Arabic'], hi: ['हिन्दी', 'Hindi'], id: ['Indonesia', 'Indonesian'], ja: ['日本語', 'Japanese'],
  ko: ['한국어', 'Korean'], zh: ['中文', 'Chinese']
};
export const ALL_LANGS = HomeShowcase.LANGS.map((id) => ({ id, label: LANG_NAMES[id]?.[0] || id.toUpperCase(), name: LANG_NAMES[id]?.[1] || id }));
export const EDIT_LANG_LIST = ALL_LANGS.filter((l) => HomeShowcase.EDIT_LANGS.includes(l.id));    // se escriben a mano
export const OTHER_LANGS = ALL_LANGS.filter((l) => !HomeShowcase.EDIT_LANGS.includes(l.id));     // se traducen

// La app usa esta fuente; el backoffice no la carga por su cuenta.
export const APP_FONT_URL = 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap';

/**
 * Deja una imagen a la medida de su carrusel antes de subirla: recortada al
 * centro a su proporción (16:9 o 9:16), reducida y en webp. El Inicio lo abre
 * todo el mundo: cada tarjeta tiene que pesar poco.
 */
export async function fitImage(file, { width, height }) {
  const bitmap = await createImageBitmap(file);
  try {
    const scale = Math.max(width / bitmap.width, height / bitmap.height);
    const w = bitmap.width * scale;
    const h = bitmap.height * scale;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(bitmap, (width - w) / 2, (height - h) / 2, w, h);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/webp', 0.9));
    if (!blob) throw new Error('No se pudo preparar la imagen');
    return blob;
  } finally {
    bitmap.close?.();
  }
}
